import { Box, CircularProgress } from '@mui/material';

/**
 * Image thumbnail for the animal / sale-catalogue search result cards: a
 * clickable button that opens the lightbox when an image is available, a
 * loading placeholder while the primary image resolves, otherwise nothing.
 */
export function CardThumbnail({
  displayImg,
  primaryImg,
  onOpen,
}: {
  displayImg: string | null | undefined;
  primaryImg: string | null | undefined;
  onOpen: () => void;
}) {
  if (displayImg) {
    return (
      <Box
        component="button"
        type="button"
        onClick={onOpen}
        aria-label="View full-size image"
        sx={{
          width: '40%',
          maxWidth: '140px',
          margin: 1,
          padding: 0,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1,
          backgroundColor: 'background.paper',
          overflow: 'hidden',
          cursor: 'pointer',
          alignSelf: 'center',
          display: 'block',
          transition: (theme) =>
            theme.transitions.create(
              ['border-color', 'box-shadow', 'transform'],
              { duration: theme.transitions.duration.shorter },
            ),
          '&:hover': {
            boxShadow: 1,
            transform: 'translateY(-2px)',
          },
          '&:focus-visible': {
            outline: '2px solid',
            outlineColor: 'primary.main',
            outlineOffset: 2,
          },
        }}
      >
        <Box
          component="img"
          src={displayImg}
          alt=""
          sx={{
            display: 'block',
            width: '100%',
            height: 'auto',
            backgroundColor: 'background.default',
          }}
        />
      </Box>
    );
  }
  if (primaryImg) {
    return (
      <Box
        sx={{
          width: '40%',
          maxWidth: '140px',
          aspectRatio: '4/3',
          margin: 1,
          alignSelf: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'background.default',
          borderRadius: 1,
          padding: 1,
        }}
      >
        <CircularProgress size={24} />
      </Box>
    );
  }
  return null;
}
